module.exports = __webpack_public_path__ + "img/814.2a0a8f69.jpg";